import React from 'react'
import { FlashSuccess } from 'common/flash'

const PaymentUpdateSuccessBanner = () => (
  <FlashSuccess>Your payment details were updated successfully.</FlashSuccess>
)

export default PaymentUpdateSuccessBanner
